module.exports = __webpack_public_path__ + "img/franchising_accomplishments_1.f4ee87c2.svg";